
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ClimateRiskDashboard } from './ClimateRiskDashboard';
import { FacilityManager } from './FacilityManager';
import { RiskDetection } from './RiskDetection';
import { ScenarioAnalysis } from './ScenarioAnalysis';
import { MitigationPlanning } from './MitigationPlanning';
import { Cloud, Building, AlertTriangle, TrendingUp, Shield } from 'lucide-react';
import { ModuleAccessGate } from '@/components/shared/ModuleAccessGate';
import { MODULE_ACCESS } from '@/constants/moduleAccess';

export const ClimateRiskMain = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <ModuleAccessGate moduleName={MODULE_ACCESS.CLIMATE_RISK_ASSESSMENT}>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Climate Risk Assessment</h1>
          <p className="text-muted-foreground">
            Comprehensive climate risk analysis and mitigation planning for your facilities
          </p>
        </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="dashboard" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Dashboard
          </TabsTrigger>
          <TabsTrigger value="facilities" className="flex items-center gap-2">
            <Building className="h-4 w-4" />
            Facilities
          </TabsTrigger>
          <TabsTrigger value="detection" className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            Risk Detection
          </TabsTrigger>
          <TabsTrigger value="scenarios" className="flex items-center gap-2">
            <Cloud className="h-4 w-4" />
            Scenarios
          </TabsTrigger>
          <TabsTrigger value="mitigation" className="flex items-center gap-2">
            <Shield className="h-4 w-4" />
            Mitigation
          </TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard" className="space-y-4">
          <ClimateRiskDashboard />
        </TabsContent>

        <TabsContent value="facilities" className="space-y-4">
          <FacilityManager />
        </TabsContent>

        <TabsContent value="detection" className="space-y-4">
          <RiskDetection />
        </TabsContent>

        <TabsContent value="scenarios" className="space-y-4">
          <ScenarioAnalysis />
        </TabsContent>

        <TabsContent value="mitigation" className="space-y-4">
          <MitigationPlanning />
        </TabsContent>
      </Tabs>
    </div>
    </ModuleAccessGate>
  );
};
